export const browserLang = () => {
  const nav = window.navigator as any;
  let browserLang = nav.language || nav.userLanguage || (nav.languages && nav.languages[0]);

  if (browserLang != 'ko' && browserLang != 'en') browserLang = 'en';

  return browserLang ? browserLang.split('-')[0] : 'en';
};
